import { Component, OnInit, OnChanges, Input} from '@angular/core';

@Component({
  selector: 'app-time-display',
  templateUrl: './time-display.component.html',
  styleUrls: ['./time-display.component.css']
})
export class TimeDisplayComponent implements OnInit, OnChanges{

  constructor() { }
  hours;
  minutes;
  seconds;

  @Input() timeInSeconds;
  @Input() secondsOnly = false;

  ngOnInit(){
    this.calcTime(this.timeInSeconds);
  }

  ngOnChanges(){
    this.calcTime(this.timeInSeconds);
  }

  calcTime(value: number) {
    this.hours = this.padNum(Math.floor(value/3600), 2);
    this.minutes = this.padNum(Math.floor((value - (parseInt(this.hours) * 3600))/60), 2);
    this.seconds = this.padNum(value - (parseInt(this.hours) * 3600) - (parseInt(this.minutes) * 60), 2);
  }

  padNum(num: number, size: number) {
    var s = String(num);
    while (s.length < size) s = "0" + s;
    return s;
  }

}
